import { dataToggle } from "../utils/toggle-dataset"
import { $Q, $Qll } from "../utils/query-selector"
import { addTagScript } from "../utils/add-tag-script";
import api from "../services/api"
import { stringToHTML } from "../utils/to-html"
import { openAccordion } from '../utils/accordion';

/**
 * The function adds a click event listener to close buttons in a modal and toggles the visibility of
 * the modal.
 * @param modal - It is a variable that represents the modal element that contains the quick shop view.
 * The function `closeQuickShop` adds a click event listener to all the close buttons within the modal,
 * and when clicked, it toggles the visibility of the modal to hide it.
 */
const closeQuickShop = (modal) => {
  const lstClose = $Qll('.close-quickview-js', modal);

  lstClose.forEach((close) => {
    close.addEventListener('click', () => {
      dataToggle($Q('#product-modal'), true);
    })
  });
}

/**
 * Calls the functions:
 * {} To capture the variants.
 * {} Makes the modification of the amounts
 * @param {object} newSection Html component to render
 */
 function updateSection(newSection) {
  const section = $Q('.quickshop-modal-js');

  section.innerHTML = newSection.innerHTML;

  closeQuickShop(section);
}

/**
 * Build the products url. Call the {shopifySectionByUrl}
 * function to return the HTML structure with the handle element.
 * @param {object} nodeHandle trigger node with its data-handle
 */
 async function dataHandle(nodeHandle) {
  $Q('.quickshop-modal-js').innerHTML = '<div class="flex"><div id="loading"></div></div>'
  const productcore = $Q('.product-core-script');
  const loadScript = await addTagScript(productcore.dataset.script, 'productCore');

  if (loadScript) {
    const dataSet = nodeHandle.dataset.handle
    const dataHandle = `/products/${dataSet}`

    const htmlResponse = await api.shopifySectionByUrl(dataHandle, 'modal-quickshop')
    const query = $Q(".quickshop-section-js", stringToHTML(htmlResponse))

    updateSection(query);
  }
}

/**
 * Performs the search for the elements that activate the rendering
 * @param {String} node activator button
 * @author Cristian Velasco
 */
export async function initQuickShop(node) {
  await dataToggle($Q('#product-modal'), true);
  await dataHandle(node);
  openAccordion($Q('#product-modal'));
  document.dispatchEvent(new
    CustomEvent("quickview:loaded"));
}

/**
 * The function `closeQuickWithKey` listens for the 'Escape' key press and closes a quick shop modal if
 * it is active.
 */
export const closeQuickWithKey = () => {
  // eslint-disable-next-line complexity
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const quickShop = $Q('#product-modal');
      const predictiveSearch = $Q('#search-predictive');

      if (!quickShop || !predictiveSearch) return;

      if (quickShop.dataset.active === 'true') {
        dataToggle(quickShop, true);
      } else if (predictiveSearch.dataset.active === 'true') {
        dataToggle(predictiveSearch, false);
      }
    }
  });
}
